import { useEffect, useRef, useState } from "react";
import "./slider.scss";
import SliderItem, { SliderItemData } from "./sliderItem";
import Hammer from "hammerjs";
import * as utils from "shell/app/app.utils";

export interface sliderProps {
  items: SliderItemData[];
}

const Slider: React.FC<sliderProps> = (props) => {
  const [iSlide, setISlide] = useState<number>(1);
  const [elWidth, setElWidth] = useState<number>();
  const sliderRef = useRef<HTMLDivElement>(null);
  const slideRef = useRef<HTMLDivElement>(null);
  const hammertime = useRef<any>(null);

  const handleItemClick = (i: number) => {
    if (i >= 0 && i < props.items.length) {
      setISlide(i);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const slide = slideRef.current;
      if (slide) {
        setElWidth(slide.children[0].clientWidth || 0);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (sliderRef.current && !hammertime.current) {
      hammertime.current = new Hammer(sliderRef.current);
      hammertime.current.set({ direction: Hammer.DIRECTION_HORIZONTAL });
      hammertime.current.on("swipeleft swiperight", (e: any) => {
        let iSlideNew =
          e.direction === Hammer.DIRECTION_LEFT
            ? iSlide + 1
            : e.direction === Hammer.DIRECTION_RIGHT
            ? iSlide - 1
            : iSlide;
        setISlide(utils.clamp(iSlideNew, 0, props.items.length));
      });
    }
    return () => {
      if (hammertime.current) {
        hammertime.current.destroy();
        hammertime.current = null;
      }
    };
  }, [iSlide, props.items.length]);

  return (
    <div className="slider" ref={sliderRef}>
      <div className="slider-container">
        <div
          className="slider__slide"
          ref={slideRef}
          style={{
            transform: `translateX(${-(elWidth || 0) * (iSlide - 1)}px)`,
          }}
        >
          {props.items.map((item, key) => (
            <SliderItem
              {...item}
              key={key}
              className="slider__child"
              index={key}
              onClick={handleItemClick}
              active={key === iSlide}
              trans={key - iSlide}
            />
          ))}
        </div>
      </div>
      <div className="slider__arrows">
        <button type="button" className="slider__arrows-arrow is-left" onClick={() => handleItemClick(iSlide - 1)} disabled={iSlide === 0}>
          <img src={utils.assetPath("/icons/arrow-left-glow.svg")} alt="" />
        </button>

        <button type="button" className="slider__arrows-arrow is-right" onClick={() => handleItemClick(iSlide + 1)} disabled={iSlide === props.items.length-1}>
          <img src={utils.assetPath("/icons/arrow-right-glow.svg")} alt="" />
        </button>
      </div>
    </div>
  );
};

export default Slider;
